<style scoped>
    @import '../assets/css/unsupportedBrowserChecker.css';
</style>
<template>
    <div class="main-container" v-show="isUserBrowserUnsupported">
        <div class="content">
            <h1>BROWSER NOT SUPPORTED</h1>
            <p>
                The TFS4JIRA Synchronizer features are currently not supported in your browser.
                Please try opening the application using the latest version of Chrome, Firefox, Safari, Opera or Edge.<br><br>
                List of supported browsers is available
                <a href="https://apps.appf.re/t4j/doc/sh/system-requirements" target="_blank">here</a>.
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            isUserBrowserUnsupported: function() {
                let userAgent = window.navigator.userAgent;
                let isIE10OrOlder = userAgent.indexOf('MSIE ') >= 0;
                let isIE11 = userAgent.indexOf('Trident/') >= 0;
                return (isIE10OrOlder || isIE11);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/UnsupportedBrowserChecker.vue